import React, { useEffect, useState } from "react";

import clsx from "clsx";

import { Tooltip, makeStyles } from "@material-ui/core";

import { copyText, numberToCurrency } from "@ip-utils";

const useStyles = makeStyles((theme) => ({
  monospace: theme.typography.monospace,
}));

export default function Amount({
  children,
  copyable = true,
  monospace = true,
  value = 0,
}) {
  const [copied, setCopied] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    return () => {
      if (copied) {
        window.clearTimeout(copied);
      }
    };
  });

  value = Math.round(parseFloat(children || value) * 100) / 100;
  const formatted = numberToCurrency(value);

  if (!copyable) {
    return formatted;
  }

  function handleCopy() {
    copyText(value, () => {
      const timeout = window.setTimeout(setCopied, 2000, false);
      setCopied(timeout);
    });
  }

  const className = clsx({
    [classes.monospace]: monospace,
  });

  return (
    <Tooltip title={copied ? "✓ Copied" : "Copy"}>
      <span className={className} onClick={handleCopy}>
        {formatted}
      </span>
    </Tooltip>
  );
}
